import styled from "styled-components";
import { Select } from "@mui/material";
import { deviceSpec } from "breakpoints";

export const StyledHeader = styled.header`
  box-shadow: 1.1px 2px 4.2px hsl(0deg 0% 0% / 0.17);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  height: 55px;
  min-height: 55px;
  z-index: 6;
  padding: 0;
  margin: 0;

  @media ${deviceSpec.isMobile} {
    flex-direction: row; 
    height: 47px;
    min-height: 47px;
  }
  
  h3 {
    font-size: ${({theme}) => theme.font.h4};
    font-weight: 550;
  }

  background-color: ${({ theme }) => theme.name === 'light-theme' ? theme.colors.white : theme.colors.background};
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  top: 0;

  .css-experience {
    margin-right: 40px;
    width: 200px;
  }

  .title {
    color: ${({ theme }) => theme.colors.textColor};
    font-size: ${({ theme }) => theme.font.large};
    font-weight: 400;
    line-height: 32px;
  }

  .hamburger-icon, .search-icon {
    display: none;
  }

  .settings-link {
    display: flex;
    justify-content: center;
  }

  @media ${deviceSpec.isLaptop} {
    padding: 1em;
    border-bottom: none;

    .title {
      font-weight: 400;
      line-height: 24px;
    }

    .hamburger-icon, .search-icon {
      display: flex;
      align-items: center;
    }
  }
  
  .hamburger-icon {
    svg, svg path {
      color: ${({ theme }) => theme.colors.textColor};
      fill:  ${({ theme }) => theme.colors.textColor};
    }
  }

  .header-icon {
    display: flex;
    flex-direction: row;
  }

  @media ${deviceSpec.isMobile} {
    padding: 1em;

    box-shadow: 0px 2px 1px -1px rgba(64, 64, 64, 0.6),
      0px 1px 1px 0px rgba(128, 128, 128, 0.3),
      0px 1px 3px 0px rgba(192, 192, 192, 0.1),
      0px 1px 5px 0px rgba(192, 192, 192, 0.05);
  }
`;

export const Breadcrumbs = styled('div')`
 li, h3, span {
  color: ${({theme}) => theme.colors.textColor};
 }
 
 a {
    transition: all 0.2s ease-in-out;
    color: ${({theme}) => theme.colors.textColor};
    text-decoration: none;
    
    &:hover {
      color: ${({ theme }) => theme.colors.highlight2};
      text-decoration: none;
    }

    &.active {
      color: ${({ theme }) => theme.colors.highlight2};
      text-decoration: none;
    }
    
    &.font-bold {
      font-weight: 700;
    }
  }
    
 @media ${deviceSpec.isMobile} {
  nav {
    display: none;
  }
 }
`

export const PipeSeparator = styled('div')`
  height: 20px;
  width: 1px;
  background-color: ${({ theme }) => theme.colors.textColor};
  opacity: 0.5;
  margin: 0 10px;
`;


export const ToggleWrapper = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;

  @media ${deviceSpec.isTablet} {
    padding: 3em;
  }

  @media ${deviceSpec.isMobile} {
    padding: 0;
  }

  .toggle-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .toggle-label {
    font-size: 14px;
    font-weight: bold;
  }

  .theme-switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 26px;
  }

  .theme-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color:${({ theme }) => theme.colors.buttonBackground};
    transition: 0.4s;
    border-radius: 50px;
  }

  .slider::before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: ${({ theme }) => theme.colors.buttonBackground};
  }

  
  input:checked + .slider::before {
    transform: translateX(24px);
  }
`;


export const HamburgerAndTitleContainer = styled('div')`
  display: flex;
  justify-content: flex-start;

  h3 {
    margin-left: 1em;
  }
`;

export const SessionButtons = styled('div')`
  display: flex;
  align-items: center;

  @media ${deviceSpec.isTablet} {
    display: none;
  }
`;

export const HomeButton = styled('div')`
  height: 38px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  cursor: pointer;
  border-radius: 4px;
  
  p, h3 {
    color: ${({theme}) => theme.colors.textColor};
    font-weight: 600;
    line-height: 24px;
    font-size: ${({ theme }) => theme.font.large};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  svg {
    color: ${({theme}) => theme.colors.textColor};
  }
`;

export const AnalystHomeButtons = styled('div')`
  display: none;
  justify-content: row;

  div:nth-child(2) svg {
    margin-left: 0.5em;
    margin-right: 0.5em;
  }

  @media ${deviceSpec.isTablet} {
    display: flex;
  }
`;

export const UserName = styled('div')`
  height: 38px;
  display: flex;
  align-items: center;

  p, h3 {
    color: ${({ theme }) => theme.colors.textColor};
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    text-align: center;
    font-size: ${({ theme }) => theme.font.large};
  }
`;

export const LogOutButton = styled('div')`
  height: 30px;
  align-self: center;
  gap: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: ${({ theme }) => theme.font.large};
  line-height: 24px;
  padding-right: 1rem;
  cursor: pointer;

  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.textColor};
  height: 38px;

  :hover {
    color: ${({ theme }) => theme.colors.buttonBorderHighlight};
    cursor: pointer;
    opacity: 0.75;
  }
`;

export const StyledSelect = styled(Select)`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textColor};
`;


export const ThemedIcon = styled.svg`
  stroke: ${({ theme }) => theme.colors.textColor};
`;
